<template>
  <div v-if="dialogShow">
    <div class="share-bak"></div>
    <div class="share-mode-pop">
      <div class="share-mode-pop__content">
        <div class="title">
          <template v-if="isEmp">
            <div v-if="commission" class="commission-info">
              <div class="commission-text">
                <span>分享最高可赚佣金</span>
                <span class="commission-num">{{ commission }}元</span>
              </div>
              <div class="cashback-text" style="text-align: left">
                {{ friendMessage }}
                <template v-if="rebateInfo.customerRebateMoney">
                  <span class="cashback-num"
                    >{{ rebateInfo.customerRebateMoney }}元</span
                  >现金奖励
                </template>
              </div>
            </div>
            <div v-if="!commission" class="commission-info">
              <div class="commission-text">
                <span>该商品暂无佣金</span>
              </div>
              <div class="cashback-text">
                <span>您可点击“返佣商品”，查看更多有佣金的商品</span>
              </div>
            </div>
          </template>
          <div class="text" v-if="!isEmp">分享方式</div>
        </div>
        <div class="share-mode">
          <div class="flex" style="margin-left: 16px">
            <div class="share-box-flex" @click="$emit('weChatCollage')">
              <div class="img">
                <img
                  class="img-100"
                  src="https://img2.coocaa.com/ui/partner-mini-program/weixin.png"
                />
              </div>
              <div class="text">微信好友</div>
            </div>
          </div>
<!--          <div class="flex" v-if="isShiWu" style="margin-left: 16px">
            <div class="share-box-flex" @click="$emit('weChatCollage')">
              <div class="img">
                <img
                  class="img-100"
                  src="https://img2.coocaa.com/ui/partner-mini-program/weixin.png"
                />
              </div>
              <div class="text">微信好友</div>
            </div>
          </div>-->
          <div v-if="isEmp" :class="['flex', !isShiWu && 'shiwuFlex']">
            <div class="share-box-flex" @click="$emit('shareCollage')">
              <div class="img">
                <img
                  class="img-100"
                  src="https://img2.coocaa.com/ui/partner-mini-program/pie.png"
                />
              </div>
              <div class="text">生成海报</div>
            </div>
          </div>
        </div>
        <div class="service-list" v-if="isEmp">
          <div
            class="service-item"
            style="width: 64px; height: 86px"
            @click="commissionDialogShow = true"
          >
            <img
              src="https://img2.coocaa.com/ui/partner-mini-program/Group-271.png"
            />
          </div>
          <wx-open-launch-weapp
            id="launch-btna"
            style=""
            username="gh_dd06d3279c38"
            path="pages/partner/subpage/rebate-goods/index"
            env-version="release"
          >
            <script type="text/wxtag-template">
              <style>
                .myimg {
                  width: 62px;
                  height: 86px;
                }
              .service-item {
                  width: 62px;
                  height: 86px;
                  margin-left: 45px;
              }</style>
                <div class="service-item">
                  <img
                    class="myimg"
                    src="https://img2.coocaa.com/ui/partner-mini-program/Group-272.png"
                  />
                </div>
            </script>
          </wx-open-launch-weapp>
          <!-- <wx-open-launch-weapp
            id="launch-btna"
            style=""
            username="gh_dd06d3279c38"
            path="pages/my/wallet-partner/index"
            env-version="release"
          >
            <script type="text/wxtag-template">
              <style>
                .myimg {
                  width: 62px;
                  height: 86px;
                }
              .service-item {
                  width: 62px;
                  height: 86px;
                  margin-left: 45px;
              }</style>
                <div class="service-item">
                  <img
                    class="myimg"
                    src="https://img2.coocaa.com/ui/partner-mini-program/Group-273.png"
                  />
                </div>
            </script>
          </wx-open-launch-weapp> -->
        </div>
        <div class="share-cancel-btn" @click="close()">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { $platformCode } from '@/common'

export default {
  name: 'common-share',
  props: {
    goodsId: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    isEmp: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['getEmpNo', 'getEmpInfo', 'isFormalEmp']),
    friendMessage () {
      let message = '好友通过你分享的页面成功购买，你可获得该商品佣金'
      if (this.rebateInfo.customerRebateMoney) {
        message = message + '，好友也可获得'
      }
      return message
    },
    dialogShow: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    isShiWu () {
      return this.goodsInfo.spuType === 1
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.getGoodsInfo()
        this.isEmp && this.getGoodsRebateMoney()
      }
    }
  },
  data () {
    return {
      goodsInfo: {
        spuType: null
      },
      rebateInfo: {
        customerRebateMoney: 0
      },
      commission: 0, // 返佣
      empTopList: {
        9000: {
          speed: 12,
          num: 0,
          tagName: '潜力',
          icon: 'https://img2.coocaa.com/ui/partner-mini-program/partner/partner-icon1.png'
        },
        9100: {
          speed: 30,
          num: 1,
          tagName: '铜牌',
          icon: 'https://img2.coocaa.com/ui/partner-mini-program/partner/partner-icon2.png'
        },
        9200: {
          speed: 50,
          num: 1000,
          tagName: '银牌',
          icon: 'https://img2.coocaa.com/ui/partner-mini-program/partner/partner-icon3.png'
        },
        9300: {
          speed: 70,
          num: 100000,
          tagName: '金牌',
          icon: 'https://img2.coocaa.com/ui/partner-mini-program/partner/partner-icon4.png'
        },
        9400: {
          speed: 100,
          num: 400000,
          tagName: '超级',
          icon: 'https://img2.coocaa.com/ui/partner-mini-program/partner/partner-icon5.png'
        }
      }, // 合伙人预估返佣列表
      commissionDialogShow: false
    }
  },
  methods: {
    getGoodsInfo () {
      this.$service.getGoodsDetails({
        skuId: this.goodsId
      }).then(res => {
        this.goodsInfo = res.data
      })
    },
    handlerCommission (val) {
      for (let key in val) {
        if (this.empTopList[key]) {
          this.empTopList[key].commission = val[key]
        }
      }
      this.commission = val[this.getEmpInfo.empTagStr]
    },
    getGoodsRebateMoney () {
      const params = {
        goodsId: this.goodsId,
        platformCode: $platformCode
      }
      this.$service.getGoodsRebateMoney(params).then(res => {
        this.rebateInfo = res.data
        this.handlerCommission(res.data.empRebateMoneys)
      })
    },
    close () {
      this.dialogShow = false
      this.commissionDialogShow = false
      this.$emit('input', false)
    },
    sharePicShow () {
      this.$emit('shareCollage')
    }
  }
}
</script>

<style scoped lang="stylus">
.myimg {
  width: 64px;
  height: 86px;
}

.shiwuFlex {
  margin-left: 16px;
}

.share-mode-pop {
  width: 100vw;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1000;
  background: #fff;
  padding-bottom: 20px;
  border-radius: 10px 10px 0 0;

  .title {
    padding: 15px;
    padding-bottom:24px;
  }

  .share-mode {
    display: flex;

    .flex {
      padding: 0;
      text-align: center;

      .share-box-flex {
        background: none;
      }

      .share-box-flex:after {
        display: none;
      }

      .img {
        width: 64px;
        height: 64px;
        margin: 0 auto;
      }

      .text {
        line-height: 30px;
        height: 30px;
        font-size: 12px;
        color: #666;
      }
    }

    .flex + .flex {
      margin-left: 42.5px;
    }
  }

  .share-cancel-btn {
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 20px;
    width: 80%;
    color: #666;
    text-align: center;
    margin: 0 auto;
    border: 1px solid #ccc;
  }
}

.share-bak {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
}

.share-box {
  width: 250px;
  position: fixed;
  left: 62.5px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;

  .share-pic {
    width: 100%;
    background: #fff;
    overflow: hidden;
    border-radius: 8px;

    .image {
      width: 100%;
      vertical-align: top;
    }
  }

  .share-btn {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    border-radius: 20px;
    color: #fff;
    background: #FA6400;
    text-align: center;
    margin: 20px auto 0;
  }
}

.share-mode-pop__content {
  position: relative;
  width: 100%;
}

.icon-box {
  position: absolute;
  right: 16px;
  top: 12px;

  .icon {
    width: 20px;
    height: 20px;
  }
}

.commission-info {
  .commission-text {
    color: #000;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
  }

  .commission-num {
    font-weight: 500;
    font-size: 16px;
    color: #FC4C00;
    margin: 0 5px;
  }

  .cashback-text {
    font-weight: 400;
    font-size: 14px;
    color: #666;
    line-height: 16px;
    text-align: center;
  }

  .cashback-num {
    font-weight: 400;
    font-size: 14px;
    color: #FC4C00;
    margin: 0 5px;
  }
}

.service-list {
  display: flex;
  padding: 0 15px;
  margin: 16px 0 30px;

  .service-item {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
